import { render, staticRenderFns } from "./BoxAddPartes.vue?vue&type=template&id=42d45bae&"
import script from "./BoxAddPartes.vue?vue&type=script&lang=js&"
export * from "./BoxAddPartes.vue?vue&type=script&lang=js&"
import style0 from "./BoxAddPartes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports